import * as vp from 'vopay';
import axios from 'axios';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type HookTuple = (requestParams: vp.ELinxSettingsSetNotificationRequest) => Promise<vp.ApiResponse>;

function usePostELinxSettingsSetNotification({ api }: HookProps): HookTuple {
  const source = axios.CancelToken.source();
  return (requestParams) => api.postELinxSettingsSetNotification(requestParams, source);
}

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostELinxSettingsSetNotification);
